import React, { useEffect, useRef, useState } from 'react'
import { ABBREVCITY_ALLOW_ARR, PLOBJ, } from '../../../../../config/constants'
import { iconwrapper } from '../../../../../config/commonfunctions'
import { BOARD_ICON, MAIN_GALLERY_ICON, MAIN_HOME_ICON, MAIN_PRICELIST_ICON, MAIN_VENDOR_ICON, THICKHEART_ICON } from '../../../../../config/svgicons'
import './Miniapptopbar.css'

const divider =  <div style={{
    width: 1,
    alignSelf: 'stretch',
    margin: '8px 4px',
    backgroundColor: 'var(--lightdark)',
    flexShrink: 0,
}} />
const APPS_KEY = ['community', 'comparevenue', 'invitation', 'seatingchart', 'checklist', 'budget', 'itinerary', 'guestbook', 'qr']
const LOGGED = 1

function Miniapptopbar(props) {
    const { auth } = props
    const wrapperRef = useRef(null)
    const barRef = useRef(null)
    const [justify, setJustify] = useState('center')
    const [abbrev_userlocation, setAbbrev_userlocation] = useState('')

    useEffect(() => {
        setAbbrev_userlocation(props.abbrev_userlocation)
    }, [props])

    const topappdivider = <div className='miniappbar_dividerroot'>
        <div className='miniappbar_dividerone' />
        <div className='miniappbar_dividertwo' style={{ right: 10, width: 4, height: 4 }} />
        <div className='miniappbar_dividertwo' />
        <div className='miniappbar_dividertwo' style={{ left: 10, width: 4, height: 4 }} />
        <div className='miniappbar_dividerthree' />
    </div>

    const btmappdivider = <div className='miniappbar_dividerroot' >
        <div className='miniappbar_dividerone' />
        <div className='miniappbar_dividertwo' style={{ right: 10, width: 4, height: 4 }} />
        <div className='miniappbar_dividertwo' />
        <div className='miniappbar_dividertwo' style={{ left: 10, width: 4, height: 4 }} />
        <div className='miniappbar_dividerthree' />
    </div>

    useEffect(() => {
        const calculate = () => {
            if (wrapperRef.current && barRef.current) {
                const wrapperWidth = wrapperRef.current.offsetWidth
                const barWidth = barRef.current.scrollWidth
                setJustify(barWidth > wrapperWidth ? 'flex-start' : 'center')
            }
        }

        const ro = new ResizeObserver(calculate)
        if (wrapperRef.current) ro.observe(wrapperRef.current)
        calculate()
        return () => ro.disconnect()
    }, [])

    const mainitems_old = <div className='miniappbar_topfirstbar'>
        <button className='miniappbar_topfirstbarbtn' style={props.currentpage === 'HOME' ? { fill: 'var(--mainpink)', color: 'var(--mainpink)' } : {}} onClick={() => props.history.push('/')}>
            <div className='miniapp_topfirstbarcol'>
                {iconwrapper(MAIN_HOME_ICON, { height: 30, width: 25, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                <div className='miniapp_topfirstbarname'>Home</div>
            </div>
        </button>
        <button className='miniappbar_topfirstbarbtn' style={props.currentpage === 'VENDOR' ? { fill: 'var(--mainpink)', color: 'var(--mainpink)' } : {}} onClick={() => props.history.push('/vendor/' + props.usertype.toLowerCase() + '/all')}>
            <div className='miniapp_topfirstbarcol'>
                {iconwrapper(MAIN_VENDOR_ICON, { height: 30, width: 25, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                <div className='miniapp_topfirstbarname'>Vendor</div>
            </div>
        </button>
        <button className='miniappbar_topfirstbarbtn' style={props.currentpage === 'GALLERY' ? { fill: 'var(--mainpink)', color: 'var(--mainpink)' } : {}} onClick={() => props.history.push('/projectgallery')}>
            <div className='miniapp_topfirstbarcol'>
                {iconwrapper(MAIN_GALLERY_ICON, { height: 30, width: 25, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                <div className='miniapp_topfirstbarname'>Gallery</div>
            </div>
        </button>
        <button className='miniappbar_topfirstbarbtn' style={props.currentpage === 'PRICELIST' ? { fill: 'var(--mainpink)', color: 'var(--mainpink)' } : {}} onClick={() => props.history.push('/pricelist/' + props.usertype.toLowerCase() + '/all')}>
            <div className='miniapp_topfirstbarcol'>
                {iconwrapper(MAIN_PRICELIST_ICON, { height: 30, width: 25, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                <div className='miniapp_topfirstbarname'>Pricelist</div>
            </div>
        </button>
    </div>



    const midiconcss = { display: 'flex', placeContent: 'center', placeItems: 'center', width: 25, height: 25 }

    const mainitems = <div className='miniappbar_topfirstbar'>
        <div className='miniappbar_topfirstbarrow'>
            <button className='miniappbar_topfirstbarbtn' style={props.currentpage === 'HOME' ? { fill: 'var(--mainpink)', color: 'var(--mainpink)' } : {}} onClick={() => props.history.push('/')}>
                <div className='miniapp_topfirstbarcol'>
                    {iconwrapper(MAIN_HOME_ICON, { height: 30, width: 25, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                    <div className='miniapp_topfirstbarname'>Home</div>
                </div>
            </button>
            <button className='miniappbar_topfirstbarbtn' style={props.currentpage === 'VENDOR' ? { fill: 'var(--mainpink)', color: 'var(--mainpink)' } : {}} onClick={() => props.history.push('/vendor/' + props.usertype.toLowerCase() + '/all')}>
                <div className='miniapp_topfirstbarcol'>
                    {iconwrapper(MAIN_VENDOR_ICON, { height: 30, width: 25, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                    <div className='miniapp_topfirstbarname'>Vendor</div>
                </div>
            </button>
            <button className='miniappbar_topfirstbarbtn' style={props.currentpage === 'GALLERY' ? { fill: 'var(--mainpink)', color: 'var(--mainpink)' } : {}} onClick={() => props.history.push('/projectgallery')}>
                <div className='miniapp_topfirstbarcol'>
                    {iconwrapper(MAIN_GALLERY_ICON, { height: 30, width: 25, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                    <div className='miniapp_topfirstbarname'>Gallery</div>
                </div>
            </button>
            <button className='miniappbar_topfirstbarbtn' style={props.currentpage === 'PRICELIST' ? { fill: 'var(--mainpink)', color: 'var(--mainpink)' } : {}} onClick={() => props.history.push('/pricelist/' + props.usertype.toLowerCase() + '/all')}>
                <div className='miniapp_topfirstbarcol'>
                    {iconwrapper(MAIN_PRICELIST_ICON, { height: 30, width: 25, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                    <div className='miniapp_topfirstbarname'>Pricelist</div>
                </div>
            </button>
        </div>
        <div className='miniappbar_mid'>
            <button className='miniappbar_midfav' onClick={() => { window.open("/favourite/vendor", "_blank") }}>
                {iconwrapper(THICKHEART_ICON, midiconcss)}
                <div className='miniappbar_icontext'>Favourite</div>
            </button>
            <div className='miniappbar_midsep' />
            <button className='miniappbar_mood' onClick={() => { window.open("/board", "_blank") }}>
                {iconwrapper(BOARD_ICON, midiconcss)}
                <div className='miniappbar_icontext'>
                    {`Mood
Board`}
                </div>
            </button>
        </div>
    </div>

    const alltools = <div ref={wrapperRef} className='miniapptopbar_wrapper' style={{ justifyContent: justify, }} >
        <div ref={barRef} className='miniappbar_subroot'>
            {auth === LOGGED
                ? APPS_KEY.map((key, index) => {
                    const { name, toolurl, iconwithoutcss, id } = PLOBJ[key]
                    if (!ABBREVCITY_ALLOW_ARR.includes(abbrev_userlocation) && key === 'comparevenue') return
                    return <React.Fragment key={key + id + index}>
                        <div
                            className='miniappbar_scroller'
                            style={props.currentpage === key ? { fill: 'var(--mainpink)', color: 'var(--mainpink)', border: '1px solid var(--mainpink)' } : {}}
                            onClick={() => APPS_KEY.includes(key) ? props.history.push(toolurl) : window.open(toolurl, '_blank')}
                        >
                            <div className='miniappbar_icon'>{iconwithoutcss}</div>
                            <div className='miniappbar_iconname'>{name}</div>
                        </div>
                        {(key === 'comparevenue' && ABBREVCITY_ALLOW_ARR.includes(abbrev_userlocation)) && (divider)}
                        {(key === 'community' && !ABBREVCITY_ALLOW_ARR.includes(abbrev_userlocation)) && (divider)}
                    </React.Fragment>
                })
                : APPS_KEY.map((key, index) => {
                    const { name, toolurl, iconwithoutcss, id } = PLOBJ[key]
                    return <React.Fragment key={key + id + index}>
                        <div
                            className='miniappbar_scroller'
                            style={props.currentpage === key ? { fill: 'var(--mainpink)', color: 'var(--mainpink)', border: '1px solid var(--mainpink)' } : {}}
                            onClick={() => APPS_KEY.includes(key) ? props.history.push(toolurl) : window.open(toolurl, '_blank')}
                        >
                            <div className='miniappbar_icon'>{iconwithoutcss}</div>
                            <div className='miniappbar_iconname'>{name}</div>
                        </div>
                        {key === 'comparevenue' && (divider)}
                    </React.Fragment>
                })
            }

        </div>
    </div>

    return <div style={{
        display: 'flex', flexDirection: 'column',
        backgroundSize: '20px 20px',
        backgroundColor: 'var(--somebeige)',
        backgroundImage: 'radial-gradient(circle, rgb(204, 204, 204) 1px, transparent 1px)',
    }}>
        {topappdivider}
        {auth === LOGGED ? mainitems : null}
        {alltools}
        {btmappdivider}
    </div>

}

export default Miniapptopbar